export const particleSkills = [
    "C++",
    "Java",
    "Kotlin",
    "Ruby",
    "React",
    "JavaScript",
    "TypeScript",
    "AWS",
    "Docker",
    "Linux",
    "Teamwork",
    "MacOS",
    "PostgreSQL",
    "MongoDB",
    "Redis",
    "DataDog",
    "Jenkins",
    "Rails",
    "AtlasSearch",
    "Elasticsearch",
    "Spring Boot",
    "Git",
];
